
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkUpsertBudgetEntryItemDto } from '../models/work-upsert-budget-entry-item-dto';

export function getUpsertBudgetEntriesDtoFormGroup() {
return new FormGroup({
    entries: new FormControl<WorkUpsertBudgetEntryItemDto[]>([]),
})
;
}
      